"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSeeMoreLink = exports.StyledContentFader = exports.StyledSeeMoreLinkContainer = exports.StyledSeeMoreContentContainer = exports.StyledSeeMoreContainer = exports.defaultStyleProps = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.defaultStyleProps = {
    whiteSpace: 'normal',
    linkColor: '#007185',
    fadeColor: '#fff',
    fadeHeight: '1.6rem'
};
const setLinkColor = (props) => {
    var _a, _b;
    const color = (_b = (props.linkColor || ((_a = props.theme.palettes) === null || _a === void 0 ? void 0 : _a.font.link))) !== null && _b !== void 0 ? _b : exports.defaultStyleProps.linkColor;
    return (0, styled_components_1.css) `
    color: ${color};
  `;
};
exports.StyledSeeMoreContainer = styled_components_1.default.div ``;
exports.StyledSeeMoreContentContainer = styled_components_1.default.div `
  overflow: hidden;
  position: relative;
  ${(props) => {
    const { seeMoreEnabled, collapsed, maxHeight, maxWidth, whiteSpace = exports.defaultStyleProps.whiteSpace } = props;
    return (0, styled_components_1.css) `
      max-width: ${maxWidth};
      white-space: ${whiteSpace};
      height: ${seeMoreEnabled && collapsed ? maxHeight : 'auto'};
      padding-bottom: ${seeMoreEnabled && !collapsed ? exports.defaultStyleProps.fadeHeight : 0};
    `;
}}
`;
exports.StyledSeeMoreLinkContainer = styled_components_1.default.div `
  width: 100%;
  opacity: 1;
  transition: opacity 0.4s ease-out;
  position: absolute;
  bottom: 0;
  ${(props) => {
    const { fadeColor = exports.defaultStyleProps.fadeColor } = props;
    return (0, styled_components_1.css) `
      background-color: ${fadeColor};
    `;
}}
`;
exports.StyledContentFader = styled_components_1.default.div `
  width: 100%;
  left: 0;
  position: absolute;
  ${(props) => {
    const { fadeHeight = exports.defaultStyleProps.fadeHeight, fadeColor = exports.defaultStyleProps.fadeColor } = props;
    return (0, styled_components_1.css) `
      height: ${fadeHeight};
      top: -${fadeHeight};
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0), ${fadeColor});
    `;
}}
`;
exports.StyledSeeMoreLink = styled_components_1.default.div `
  display: flex;
  cursor: pointer;
  align-items: center;
  ${setLinkColor}
`;
